var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item && Object.keys(_vm.item).length > 0)?_c('div',{staticClass:"text-muted"},[_c('vue-json-pretty',{attrs:{"data":_vm.item,"deep":3,"showLength":""}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }